import styled from 'styled-components';
import { TitleGroup } from './TitleGroup.styled';

export const RoomsGroup = styled.div`
    flex-basis: 100%;

    > ${TitleGroup} {
        margin-bottom: 25px;
    }
`;
